import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { LawLibraryHomeComponent } from './law-library-home/law-library-home.component';
import { LawLibraryNavComponent } from './law-library-nav/law-library-nav.component';
import { LawLibraryViewComponent } from './law-library-view/law-library-view.component';
import { LawLibraryPreviewComponent } from './law-library-preview/law-library-preview.component';
import { NavItemComponent } from './law-library-nav/nav-item/nav-item.component';
import { LawLibraryEditorComponent } from './law-library-editor/law-library-editor.component';
import { FormControlBaseModule } from '../form-controls/component-base/form-control-base.module';
import { LunaCommonModule } from '../common/common.module';
import { LawService } from './services/law.service';
import { NavService } from "./services/nav.service";
import { LawLibraryEditorResolver } from './law-library-editor/resolvers/law-library-editor.resolver';
import { LawLibraryViewResolver } from './law-library-view/resolvers/law-library-view.resolver';
import { RouterModule } from '@angular/router';
import { PipesModule } from '../common/pipes/pipes.module';
import { LunaCoreModule } from "../core/core.module";

@NgModule({
    imports: [
        LunaCoreModule,
        CommonModule,
        LunaCommonModule,
        FroalaEditorModule,
        FroalaViewModule,
        PipesModule,
        RouterModule,
        LunaCommonModule,
        FormControlBaseModule,
        ReactiveFormsModule
    ],
    providers: [
        LawService,
        NavService,
        LawLibraryEditorResolver,
        LawLibraryViewResolver
    ],
    declarations: [
        LawLibraryHomeComponent,
        LawLibraryNavComponent,
        LawLibraryViewComponent,
        NavItemComponent,
        LawLibraryEditorComponent,
        LawLibraryPreviewComponent
    ],
    exports: [
        LawLibraryViewComponent,
        LawLibraryNavComponent
    ]
})
export class LawLibraryModule { }
